
<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Föreningsstämma</h5>

    <h6 style="font-weight: 500;">Mötesschema</h6>
    <h6>{$selectedItem?.general_meeting?.schedule ?? "Uppgifter saknas"}</h6>
    
    <h6 style="font-weight: 500;">Agendapunkter</h6>
    <h6>{$selectedItem?.general_meeting?.agenda_items ?? "Uppgifter saknas"}</h6>
    
    <h6 style="font-weight: 500;">Tidsfrist</h6>
    <h6>{$selectedItem?.general_meeting?.notice_period ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Röstvillkor</h6>
    <h6>{$selectedItem?.general_meeting?.voting_rights?.proxy_voting ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.general_meeting?.voting_rights?.voting_process ?? "Uppgifter saknas"}</h6>
</div>